import { Descriptions, Divider, Drawer } from "antd";
import moment from "moment";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

function MembersView({ onClose, open, prodd }) {
  const url = "prod/get_member";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
  })); 
  const navigate = useNavigate();
console.log("data000000",data)
  const items1 = [
    {
      key: "0",
      label: "Full Names",
      children: data?.fullNames ?? "N/A",
    },
    {
      key: "1",
      label: "ID Number",
      children: data?.usrNationalId ?? "N/A",
    },
    {
      key: "5",
      label: "County",
      children: data?.countyName ?? "N/A",
    },
    {
      key: "2",
      label: "Email",
      children: data?.email ?? "N/A",
    },
    {
      key: "3",
      label: "Subcounty",
      children: data?.subCountyName ?? "N/A",
    },
    {
      key: "4",
      label: "Phone",
      children: data?.phoneNumber ?? "N/A",
    },
    {
      key: "6",
      label: "Registration Date",
      children: (
        <div>
          {data?.createdDate
            ? moment(data?.createdDate)?.format("DD-MM-YYYY")
            : "--"}
        </div>
      ),
    },
  ];
  const items2 = [
    {
      key: "1",
      label: "Land Size",
      children: data?.landSize ?? "N/A",
    },
    {
      key: "5",
      label: "Water Source",
      children: data?.waterSource ?? "N/A",
    },
    {
      key: "2",
      label: "Major Crops",
      children: data?.majorCrops ?? "N/A",
    },
  ];
  const items3 = [
    {
      key: "1",
      label: "Name",
      children: data?.alternateContact ?? "N/A",
    },

    {
      key: "2",
      label: "Phone",
      children: data?.alternatePhoneNumber ?? "N/A",
    },
  ];

  return (
    <Drawer width={800} title="Basic Drawer" open={open} onClose={onClose}>
      <div className="flex justify-between items-center">
        <div className="details_h">Member Infomation</div>
      </div>

      <div className="mt-[1rem]">
        <Divider />
      </div>
      <div className="w-full mt-[2.75rem] flex">
        <Descriptions
          title="Member Details"
          column={1}
          colon={false}
          items={items1}
          layout="vertical"
        />
        <Descriptions
          title="Farm Details"
          column={1}
          colon={false}
          items={items2}
          layout="vertical"
        />
        <Descriptions
          title="Alternate Contact Person"
          column={1}
          colon={false}
          items={items3}
          layout="vertical"
        />
      </div>
    </Drawer>
  );
}

export default MembersView;
